import ActionsForm from '@/shared/mixins/actionsForm'
import SubGroupDetail from '../TemplateDetail/SubGroupDetail/SubGroupDetail.vue'
import qmaTemplateQuestion from '@/shared/http/repositories/business/qmaTemplateQuestion'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
// import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'prerequisiteTemplate',
  props: ['templateid'],
  components: {SubGroupDetail},
  mixins: [ActionsForm],
  data () {
    return {
      preRequisito: true,
      notFound: ImageNotFound,
      dadosSubGrupo: [],
      EtapaId: null,
      semEtapa: false
    }
  },
  watch: {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    popUpAddRequisito () {
      this.$refs.subGroup.abrirPopUpPreRequisitoButtoHeader(this.EtapaId)
    },
    popUpExcluirRequisito () {
      this.$refs.subGroup.abrirModalExcluirPergunta()
    },
    onLoad () {
      qmaTemplateQuestion.GetPreRequisitos(this.templateid)
        .then((Response) => {
          loading.pop()
          if (Response.data.length > 0) {
            this.semEtapa = false
            this.$emit('semEtapaPreRequisito', this.semEtapa)
            this.EtapaId = Response.data[0].etapaId
            this.dadosSubGrupo = Response.data
          } else {
            this.semEtapa = true
            this.$emit('semEtapaPreRequisito', this.semEtapa)
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('Informações não encontradas')
        })
    },
    criarPreRequisito () {
      loading.push()
      qmaTemplate.CriacaoQMAPreRequisitoWeb(this.templateid)
        .then((Response) => {
          loading.pop()
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('dados invalidos para criação')
        })
    },
    NovaPerguntaPreRequisito (value) {
      this.$emit('NovaPerguntaPreRequisito', value)
    },
    EditaPreRequisitoNovaPergunta (value) {
      this.$emit('EditaPreRequisitoNovaPergunta', value)
    },
    ExcluirNovaPerguntaPreRequisito (value) {
      this.$emit('ExcluirNovaPerguntaPreRequisito', value)
    },
    EditaPreRequisitoPergunta (value) {
      this.$emit('EditaPreRequisitoPergunta', value)
    },
    ExcluirPerguntaPreRequisito (value) {
      this.$emit('ExcluirPerguntaPreRequisito', value)
    },
    RemoverExclusaoPerguntaPreRequisito (value) {
      this.$emit('RemoverExclusaoPerguntaPreRequisito', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/prerequisiteTemplate/prerequisiteTemplate.js